import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { truncateNumber } from "../../../../utils/common";
import styles from "../../../../styles/gri/general.module.css";

const AddTable = ({
  title,
  addTables,
  setaddTables,
  errors,
  setErrors,
  inputData,
  handleAdd,
  disabled,
  hide
}) => {
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteDilog, setDeleteDialog] = useState(false);
  const [isFilleds, setIsFilled] = useState({});
  const handleChangeTable = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
    setaddTables((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index

        [name]: value,
        // Update the specific field dynamically
      };
      return newData;
    });
    // setaddTables((prev) =>
    //     prev.map((row, rowIndex) =>
    //         console.log(row,rowIndex,"setAddTables")
    //     //   rowIndex === index
    //         // ? { ...row, [name]: value } // Update only the matching row
    //     //     : row // Keep other rows unchanged
    //     ))
  };
  console.log(errors,"addTables")
  useEffect(() => {
    checkIfAdded();
  }, [addTables, inputData]); // Run only when addTables or inputData change

  const flattenObject = (obj, prefix = "") => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object" && value !== null) {
        Object.assign(acc, flattenObject(value, newKey)); // Recursively flatten nested objects
      } else {
        acc[newKey] = value;
      }
      return acc;
    }, {});
  };

  const isFilled = (value) => {
    return (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0)
    );
  };

  const checkIfAdded = () => {
    if (!Array.isArray(addTables)) {
      console.warn("⚠️ addTables is not an array!");
      return;
    }

    let newIsFilled = "";
    addTables.forEach((table, tableIndex) => {
      console.log(`🔍 Checking Table ${tableIndex}:`, addTables, table);

      if (typeof table !== "object" || table === null) {
        console.warn(`⚠️ Table ${tableIndex} is invalid!`);
        newIsFilled = true; // Mark as incomplete if it's not a valid object
        return;
      }

      const flattenedTable = flattenObject(table);
      console.log(`📝 Flattened Table ${tableIndex}:`, flattenedTable);

      // Check if any required fields are empty
      const hasEmptyFields = Object.entries(flattenedTable)
        .filter(([key]) => !key.startsWith("measurementUnit"))
        .some(([, value]) => value === "" || value === null);
      // const hasEmptyFields = Object.values(flattenedTable).some(value => value === "" || value === null);
      console.log("findObjects", Object.values(flattenedTable));
      // Validate measurement unit rules
      const massActive = flattenedTable["measurementUnit.mass.active"] === true;
      const volumeActive =
        flattenedTable["measurementUnit.volume.active"] === true;
      const massRemark = flattenedTable["measurementUnit.mass.remark"];
      const volumeRemark = flattenedTable["measurementUnit.volume.remark"];

      const massValid = massActive ? isFilled(massRemark) : true;
      const volumeValid = volumeActive ? isFilled(volumeRemark) : true;

      console.log(
        `📌 Active Mass: ${massActive}, Remark: "${massRemark}" - Valid: ${massValid}`
      );
      console.log(
        `📌 Active Volume: ${volumeActive}, Remark: "${volumeRemark}" - Valid: ${volumeValid}`
      );

      // A table is complete if it has valid measurement units and no empty required fields
      const isComplete = massValid && volumeValid && !hasEmptyFields;

      console.log(
        `✅ Final Status for Table${!hasEmptyFields} ${tableIndex}: ${
          isComplete ? "Complete" : "Incomplete"
        }`
      );

      newIsFilled = !isComplete; // Mark incomplete tables as true
    });

    // Ensure only the last table is marked incomplete
    // const lastIndex = addTables.length - 1;
    // Object.keys(newIsFilled).forEach((key) => {
    //   newIsFilled[key] = parseInt(key) === lastIndex;
    // });

    console.log("🛠️ Final Validation State:", newIsFilled);
    setIsFilled(newIsFilled);
  };

  // const handleChangeNumberTable = (e, index) => {
  //   const { name, value } = e.target;
  //   if (!/^\d*$/.test(value)) return;
  //   console.log(name, value, index, "handleChangeTable");
  //   // setaddTables((prev) => {
  //   //   const newData = [...prev]; // Create a shallow copy of the array
  //   //   newData[index] = {
  //   //     ...newData[index], // Copy the object at the given index

  //   //       [name]: value,
  //   //     // Update the specific field dynamically
  //   //   };
  //   //   return newData;
  //   // });

  //   setaddTables((prev) => {
  //     const newData = [...prev]; // Create a shallow copy of the array
  //     const currentRow = newData[index];

  //     // Prevent productPackaging from being greater than productSold
  //     if (name === "productPackaging") {
  //       const productSold = parseFloat(currentRow.productSold) || 0;
  //       if (parseFloat(value) < productSold) {
  //         return prev; // Prevent update
  //       }
  //     }

  //     // Prevent productSold from being less than productPackaging
  //     if (name === "productSold") {
  //       const productPackaging = parseFloat(currentRow.productPackaging) || 0;
  //       if (parseFloat(value) > productPackaging) {
  //         return prev; // Prevent update
  //       }
  //     }

  //     // Update value if conditions are met
  //     newData[index] = {
  //       ...newData[index],
  //       [name]: value, // Update the specific field dynamically
  //     };

  //     return newData;
  //   });
  // };

  const handleChangeNumberTable = (e, index) => {
    const { name, value } = e.target;
  
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;
  
    setaddTables((prev) => {
      const newData = [...prev];
      const currentRow = { ...newData[index] };
  
      const numValue = parseFloat(value) || 0;
  
      // Validation rules (align with AddmultipleTables logic)
      // When editing productPackaging (input), if it becomes less than current productSold (recycled),
      // clear productSold but allow the update to productPackaging.
      if (name === "productPackaging") {
        const productSold = parseFloat(currentRow.productSold) || 0;
        if (numValue < productSold) {
          currentRow.productSold = "";
        }
      }

      // When editing productSold (recycled), if it exceeds productPackaging (input), block the update.
      if (name === "productSold") {
        const productPackaging = parseFloat(currentRow.productPackaging) || 0;
        if (numValue > productPackaging) {
          return prev; // Block invalid update
        }
      }
  
      // Update the changed field
      currentRow[name] = value;
  
      // Recalculate percentage immediately
      const productPackaging = parseFloat(currentRow.productPackaging) || 0;
      const productSold = parseFloat(currentRow.productSold) || 0;
  
      currentRow.percentage =
        productSold > 0 && productPackaging > 0
          ? Number((productSold / productPackaging) * 100).toFixed(2)
          : 0;
  
      // Save updated row back into the array
      newData[index] = currentRow;
  
      return newData;
    });
  };
  
  const handleDeleteRow = () => {
    console.log(deleteIndex, "delete country");
    setDeleteDialog(false);
    setaddTables((prev) => prev.filter((_, i) => i !== deleteIndex));
  };

  return (
    <>
      <p className={styles.ques_heading}>{title}</p>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          mt: "1rem",
          borderRadius: "10px",
          ml: 2,
          width: "98%"
        }}
      >
        <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
          <TableHead>
            <TableRow
              sx={{
                borderRadius: "10px",
                backgroundColor: "#1C486B",
                border: "1px solid #ddd",
              }}
            >
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  width: "10rem",
                }}
              >
                {"S. No."}
              </TableCell>
              {inputData?.fields?.map((field) => (
                <TableCell
                  key={field.fieldName}
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: "20rem",
                  }}
                >
                  {field.title}
                </TableCell>
              ))}
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  width: "5rem",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {addTables.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
              {/* Serial Number (Roman) */}
              <TableCell sx={{width:"9%",textAlign:"center"}}>{
                (function toRoman(n){
                  const romanMap = [
                    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
                    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
                    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
                  ];
                  let num = n, result = '';
                  for (const [val, sym] of romanMap) {
                    while (num >= val) { result += sym; num -= val; }
                  }
                  return result;
                })(rowIndex + 1)
              }</TableCell>

                {inputData?.fields?.map((field, index) => (
                  <TableCell
                    sx={{
                      border: "1px solid #DBDBDB",
                      py: "0.5rem",
                      width: inputData?.colwidth ? inputData?.colwidth : "63%",
                      maxWidth: "100%",
                      background: "white",
                    }}
                    key={index}
                  >
                    <TextField
                      sx={{ width: "100%" }}
                      disabled={disabled || field.fieldName === "percentage"? true : false}
                      name={field.fieldName}
                      value={row?.[field.fieldName] || ""}
                      placeholder={field?.type==="number"?"Enter Number":"Enter Text"}
                      type="text"
                      multiline
                      minRows={1}
                      size="small"
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      onChange={(e) =>
                        field.type === "number"
                          ? handleChangeNumberTable(e, rowIndex)
                          : field.fieldName === "percentage"
                          ? ""
                          : handleChangeTable(e, rowIndex)
                      }
                    />
                  </TableCell>
                ))}

                {/* Delete Row Button */}
                <TableCell>
                  <Dialog
                    open={deleteDilog}
                    onClose={() => setDeleteDialog(false)}
                  >
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Do you really want to delete this entry?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() => setDeleteDialog(false)}
                        color="primary"
                      >
                        Cancel
                      </Button>
                      <Button
                        // onClick={handleDeleteAggree}
                        onClick={() => handleDeleteRow()}
                        color="secondary"
                      >
                        Confirm
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <IconButton
                    onClick={() => { setDeleteDialog(true)
                  setDeleteIndex(rowIndex)}}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add Row Button */}
      {!hide &&
      <Box textAlign="right">
        <Button
          disabled={isFilleds || disabled}
          variant="contained"
          onClick={handleAdd}
          sx={{
            mt: "1rem",
            backgroundColor: "#1C486B",
            color: "white",
          }}
        >
          <AddIcon />
          Add Row
        </Button>
      </Box>
}
    </>
  );
};
export default AddTable;
